import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDbfASsFhLg8cI71t2ElU3uhhsTkQqI7ns",
  authDomain: "residents-show.firebaseapp.com",
  databaseURL: "https://residents-show.firebaseio.com",
  projectId: "residents-show",
  storageBucket: "residents-show.appspot.com",
  messagingSenderId: "567710001317",
  appId: "1:567710001317:web:3c966235b9368f8494454c",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();
// export const storage = firebase.storage();

let authenticated = false;

export async function ensureFirebaseAuth() {
  if (!authenticated) {
    await firebase.auth().signInAnonymously();
    authenticated = true;
  }
}

const FILE_DOMAIN = "https://www.yorb.pw";

export function getDownloadUrl(filePath) {
  return `${FILE_DOMAIN}${filePath}`;
}
